import { TYPES } from "../../../config/constants/typesReducers";


//Lista de acciones que se pueden ejecutar en el reducer
const { AUTHENTICATION } = TYPES;

// Estado inicial con usuario null (será cargado desde localStorage si existe JWT)
export const initialStateUser = {
    user: null
}

const userReducer = (initialState = {}, action = { type:'', payload:'' }) => {
    switch(action.type){
        case AUTHENTICATION.LOGIN:
            return {
                ...initialState,
                'user': action.payload
            }
        case AUTHENTICATION.LOGOUT:
            return{
                ...initialState,
                'user': null
            }

        default:
            return initialState;
    }
}

export default userReducer;